import { Input, Checkbox, Space, Button } from "antd"
import Highlighter from "react-highlight-words"
import { CODE_FETCHING } from "./constants"
import { SearchOutlined } from "@ant-design/icons"

export const findMax = (array) =>
  array.reduce((prev, current) => (prev.y > current.y ? prev : current))

export const sumArray = (array) => array.reduce((tempSum, a) => tempSum + a)

export const parent = (e) => e.parentNode

export const random = (number = 1000) => Math.round(Math.random() * number)

export const isNotFromIframe = () => {
  return window.self === window.top
}

export const uuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c == "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export const validate = {
  array: (key) => {
    if (
      key === undefined ||
      typeof key === "undefined" ||
      key === null ||
      key.length < 0
    ) {
      return false
    }

    return true
  },
  string: (key) => {
    if (
      key === undefined ||
      typeof key === "undefined" ||
      key === null ||
      key.trim().length < 0
    ) {
      return false
    }

    return true
  },
  object: (key) => {
    if (
      key === undefined ||
      typeof key === "undefined" ||
      key === null ||
      Object.keys(key).length === 0
    ) {
      return false
    }

    return true
  },
  number: (key) => {
    if (
      key === undefined ||
      typeof key === "undefined" ||
      key === null ||
      Number.isNaN(parseFloat(key)) ||
      !Number.isFinite(Number(key))
    ) {
      return false
    }

    return true
  },
  exist: (key) => {
    if (
      key === undefined ||
      typeof key === "undefined" ||
      key === null ||
      key === "null"
    ) {
      return false
    }

    return true
  },
  func: (key) => {
    if (typeof key !== "function") {
      return false
    }

    return true
  },
  mail: (text) => {
    if (typeof text !== "string") {
      return false
    }

    const regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    return !!regex.test(text)
  },
  password: (text, size = 6) => {
    if (text.length >= size) {
      let mayuscula = false
      let minuscula = false
      let numero = false
      let caracter_raro = false

      for (let i = 0; i < text.length; i++) {
        if (text.charCodeAt(i) >= 65 && text.charCodeAt(i) <= 90) {
          mayuscula = true
        } else if (text.charCodeAt(i) >= 97 && text.charCodeAt(i) <= 122) {
          minuscula = true
        } else if (text.charCodeAt(i) >= 48 && text.charCodeAt(i) <= 57) {
          numero = true
        } else {
          caracter_raro = true
        }
      }

      if (
        mayuscula === true &&
        minuscula === true &&
        caracter_raro === true &&
        numero === true
      ) {
        return true
      }
    }

    return false
  },
  status: (key) => {
    if (
      (key !== undefined ||
        typeof key !== "undefined" ||
        key !== null ||
        key !== "null") &&
      (key === true || key === "true" || key === CODE_FETCHING.success.ok)
    ) {
      return true
    }

    return false
  },
  empty: (key) => {
    return [undefined, "", null, "undefined", "null"].includes(key)
  },
}

export const round = (num, decimals = 2) =>
  Math.round(num * 10 ** decimals) / 10 ** decimals

export const getCleanedString = (cadena, separator = "_") => {
  if (typeof cadena !== "string") {
    return cadena
  }
  // Definimos los caracteres que queremos eliminar
  const specialChars = "!@#$^&%*()+=-[]/{}|:<>?,."

  // Los eliminamos todos
  for (let i = 0; i < specialChars.length; i++) {
    cadena = cadena.replace(new RegExp(`\\${specialChars[i]}`, "gi"), "")
  }

  // Lo queremos devolver limpio en minusculas
  cadena = cadena.toLowerCase()

  // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
  cadena = cadena.replace(/ /g, separator)

  // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
  cadena = cadena.replace(/á/gi, "a")
  cadena = cadena.replace(/é/gi, "e")
  cadena = cadena.replace(/í/gi, "i")
  cadena = cadena.replace(/ó/gi, "o")
  cadena = cadena.replace(/ú/gi, "u")
  cadena = cadena.replace(/ñ/gi, "n")
  return cadena
}

export const searchTree = (data, idDimensionParent) => {
  if (!validate.exist(data) || data.length === 0) {
    return null
  }
  const item = data.find((element) => element.id == idDimensionParent)
  if (!validate.exist(item)) {
    let i
    let result = null
    for (i = 0; result == null && i < data.length; i++) {
      result = searchTree(data[i].childs, idDimensionParent)
    }
    if (validate.exist(result)) {
      return result
    }
  }
  if (validate.exist(item)) {
    return item.childs
  }
}

export const searchItemInTree = (data, idDimensionParent) => {
  if (!validate.exist(data) || data.length === 0) {
    return null
  }
  const item = data.find((element) => element.id == idDimensionParent)
  if (!validate.exist(item)) {
    let i
    let result = null
    for (i = 0; result == null && i < data.length; i++) {
      result = searchItemInTree(data[i].childs, idDimensionParent)
    }
    if (validate.exist(result)) {
      return result
    }
  }
  if (validate.exist(item)) {
    return item
  }
}

export const truncateText = (text, lengthCharacters = 25) => {
  return text.length >= lengthCharacters
    ? text.substr(0, lengthCharacters).concat("...")
    : text
}

export const browserSize = () => {
  var bs = [0, 0]
  if (typeof window.innerWidth != "undefined") {
    bs = { width: window.innerWidth, height: window.innerHeight }
  } else if (
    typeof document.documentElement != "undefined" &&
    typeof document.documentElement.clientWidth != "undefined" &&
    document.documentElement.clientWidth != 0
  ) {
    bs = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    }
  } else {
    bs = {
      width: document.getElementsByTagName("body")[0].clientWidth,
      height: document.getElementsByTagName("body")[0].clientHeight,
    }
  }
  return bs
}
